// src/components/MetaManager.jsx

import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import axios from 'axios';
import { api } from '../Costants';

const MetaManager = () => {
  const location = useLocation();
  const [meta, setMeta] = useState(null);
  
useEffect(() => {
  const fetchMeta = async () => {
    try {
      const res = await axios.post(`${api}meta_api`);
      const allMeta = res.data?.records || [];

      let currentPath = location.pathname.replace(/^\/|\/$/g, '').toLowerCase();
      if (!currentPath) {
        currentPath = 'home';
      }

      const matchedMeta = allMeta.find(item =>
        item.meta_slug?.trim().toLowerCase() === currentPath
      );

      setMeta(matchedMeta || null);
    } catch (err) {
      console.error('Meta fetch error:', err);
    }
  };

  fetchMeta();
}, [location.pathname]);

  return (
    <>
      {meta && (
        <>
          <Helmet>
            <title>{meta.meta_title}</title>
            <meta name="description" content={meta.meta_description} />
            <meta name="keywords" content={meta.meta_keywords} />
            <meta property="og:title" content={meta.meta_title} />
            <meta property="og:description" content={meta.meta_description} />
          </Helmet>

          {/* 👇 Optional: Show description visibly on the page */}
          <div className="meta-description-container" style={{ padding: '10px 0' }}>
            <p style={{ fontSize: '1rem', color: '#555' }}>
              {meta.meta_description}
            </p>
          </div>
        </>
      )}
    </>
  );
};

export default MetaManager;
